import React, { Component } from "react";
import { connect } from "react-redux";
import { RichText } from "@sitecore-jss/sitecore-jss-react";
import { addTransition } from "../../redux/actions/actions";
import { toggleIframe } from "../../redux/actions/model";
import { withRouter } from "react-router-dom";
import Icon from "../../elements/icon";
import "./style.scss";
import classNames from "classnames";
import { openModal } from "../../utils";
class CTABanner extends Component {
  handleClick(event) {
    const { fields, addTransition } = this.props;
    const {
      isPageTransition,
      link,
      pageTransitionTitle,
      pageTransitionCurtainDirection,
      pageTransitionCurtainColor,
      isShowModal,
      nestedGrid
    } = fields;
    if (isPageTransition && isPageTransition.value) {
      event.preventDefault();
      addTransition(
        "page-curtain",
        link && link.value.href,
        pageTransitionTitle && pageTransitionTitle.value,
        (pageTransitionCurtainDirection &&
          pageTransitionCurtainDirection.fields &&
          pageTransitionCurtainDirection.fields.phrase.value ===
            "right-to-left") ||
          false,
        link && link.value.linktype,
        pageTransitionCurtainColor &&
          pageTransitionCurtainColor.fields &&
          pageTransitionCurtainColor.fields.phrase.value
      );
      return;
    }
    if (isShowModal && isShowModal.value) {
      this.props.toggleIframe("", nestedGrid.value);
      openModal(link.value.id);
      return;
    }
    if (link && link.value) {
      if (link.value.linktype === "internal") {
        this.props.history.push(link.value.href || `/${this.props.lang}/404`);
      } else {
        window.open(link.value.href);
      }
    }
  }
  render() {
    if (!this.props.fields) return null;
    const { fields, rendering } = this.props;
    const {
      paddingAboveTop,
      paddingAboveBottom,
      colorScheme,
      alignment,
      text,
      iconName,
      gridType
    } = fields;
    let grid = gridType ? gridType.fields.phrase.value : "normal",
      top = paddingAboveTop ? paddingAboveTop.fields.phrase.value : "tiny",
      bottom = paddingAboveBottom
        ? paddingAboveBottom.fields.phrase.value
        : "tiny";
    const ctaClasses = classNames(
      "cta-banner",
      "padding-top-" + top,
      "padding-bottom-" + bottom,
      colorScheme && colorScheme.fields.phrase.value,
      {
        center: alignment && alignment.fields.phrase.value === "center",
        right: alignment && alignment.fields.phrase.value === "right",
        grid: grid === "normal",
        "grid-story": grid === "story"
      }
    );
    return (
      <div className={ctaClasses} datasourceid={rendering.dataSource}>
        <div className={"action"} onClick={this.handleClick.bind(this)}>
          {text && <RichText field={text} className={"text"} tag="span" />}
          {iconName && iconName.value && (
            // <i className="material-icons-sharp cta-icon">
            //   {iconName.fields.phrase.value}
            // </i>

            <Icon icon={{ ...iconName.value, className: "cta-icon" }} />
          )}
        </div>
      </div>
    );
  }
}
const mapDispatchToProps = {
  addTransition: addTransition,
  toggleIframe: toggleIframe
};
// export default CTABanner;
export default withRouter(connect(null, mapDispatchToProps)(CTABanner));
